var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useUnmute } from 'hx-util';
import { createContext, useEffect, useRef, useState, } from 'react';
export var AudioPlayerContext = createContext({});
export var AudioPlayerProvider = function (_a) {
    var children = _a.children;
    var AudioCtx = window.AudioContext || window.webkitAudioContext || null;
    var _b = useState(1), volume = _b[0], setVolume = _b[1];
    var audioContextRef = useRef(new AudioCtx());
    var audioContext = audioContextRef.current;
    var masterGainRef = useRef(audioContext.createGain());
    var masterGain = masterGainRef.current;
    masterGain.connect(audioContext.destination);
    useUnmute(audioContext);
    useEffect(function () {
        masterGain.gain.value = volume;
    }, [volume]);
    return (_jsx(AudioPlayerContext.Provider, __assign({ value: { audioContext: audioContext, masterGain: masterGain, setVolume: setVolume } }, { children: children })));
};
export default AudioPlayerProvider;
